module.exports = "/_next/static/images/Trend03Visual-3243c9ada3aa5aad5bc183e423f93d60.webp";